import type { MaybeRefOrGetter } from "vue";
import { computed, toValue } from "vue";

export function usePageJsonLd(
  page: MaybeRefOrGetter<Record<string, any> | null | undefined>,
  path: MaybeRefOrGetter<string>,
) {
  const { siteUrl } = useRuntimeConfig().public;

  useJsonLdHead(
    computed(() => {
      const pageValue = toValue(page);
      const pathValue = toValue(path);
      if (!pageValue) return null;
      return withBreadcrumbJsonLd(
        buildWebPageJsonLd(pageValue, pathValue, siteUrl),
        pathValue,
        siteUrl,
      );
    }),
  );
}
